import React, { useState, useEffect, useRef } from "react";
import { Table, Pagination, Form } from "react-bootstrap";
import UserModalForm from "../../Forms/User/UserModalForm";
import { useHistory } from "react-router";

import ReactTooltip from "react-tooltip";

import { useDispatch, useSelector } from "react-redux";

import { userActions } from "../../../_actions";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faPlus,
  faTrashAlt,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";

import Spinner from "../Spinner";

import "./UserList.css";

const UserList = (props) => {
  const {
    userType,
    isCurrentUserAdmin,
    isAccountPrimaryUser,
    currentUserAccountId,
  } = props; // type of user: user/client
  const [editMode, setEditMode] = useState(false);
  const [show, setShow] = useState(false);
  const [requiredItem, setRequiredItem] = useState(0);
  const users = useSelector((state) => state.users);
  const loading = useSelector((state) => state.users.loading);
  // const [statusSwitcher, setStatusSwitcher] = useState(true);

  const dispatch = useDispatch();
  const history = useHistory();

  const userListData = users.items ? users.items : [];

  const mounted = useRef();

  useEffect(() => {
    // only on componentDidMount event
    if (!mounted.current) {
      mounted.current = true;
      if (userType === "user") {
        if (isCurrentUserAdmin === 1) {
          dispatch(userActions.getAllUsers());
        } else if (isAccountPrimaryUser === 1) {
          dispatch(userActions.getAccountUsers(currentUserAccountId));
        }
      } else if (userType === "client") {
        dispatch(userActions.getAllClients());
      }
    } else {
      // do componentDidUpate logic
    }
  }, [
    dispatch,
    userType,
    isCurrentUserAdmin,
    isAccountPrimaryUser,
    currentUserAccountId,
  ]);

  const handleModalShow = () => {
    setShow(true);
  };

  const handleModalClose = () => {
    setShow(false);
  };

  function replaceModalItem(index) {
    setRequiredItem(index);
    setEditMode(true);
    setShow(true);
  }

  function openModalFormInAddMode() {
    setEditMode(false);
    setShow(true);
  }

  function createItem(item) {
    return {
      accountId: item.accountId,
      firstName: item.firstName,
      lastName: item.lastName,
      username: item.username,
      isAdmin: item.isAdmin,
      isClient: item.isClient,
      isUser: item.isUser,
      status: item.status,
      email: item.email,
      phone: item.phone,
      password: item.password,
      requireLogin: item.requireLogin,
    };
  }

  const saveModalDetails = (item) => {
    console.log("item - ", item);
    let tempUserListData = userListData;
    if (editMode) {
      // update user mode
      tempUserListData[requiredItem] = {
        ...item,
      };
      dispatch(userActions.update(item));
    } else {
      // create new account user mode
      const newItem = createItem(item);
      dispatch(userActions.register(newItem));
    }
    setShow(false);
    handleModalClose();
  };

  const deleteItem = (index) => {
    // console.log("index - ", index);
    // let tempUsers = userListData;
    // tempUsers.splice(index, 1);
    // setBrochure(tempBrochure);
    history.replace();
  };

  const switchValue = (value, index, item) => {
    let tempUserListData = userListData;
    tempUserListData[index] = {
      ...item,
      [value]: item[value] === 1 ? 0 : 1,
    };
    dispatch(userActions.update(tempUserListData[index]));
  };

  const moveClientToUser = (index, item) => {
    let tempUserListData = userListData;
    tempUserListData[index] = {
      ...item,
      isClient: 0,
      isUser: 1,
    };
    dispatch(userActions.moveClientToUser(tempUserListData[index]));
  };

  function addUserAccountButton() {
    return (
      <div className="user-list-add-user-link float-right">
        <button
          type="button"
          className="btn btn-outline-primary btn-sm user-list-action-btn"
          onClick={() => openModalFormInAddMode()}
        >
          <FontAwesomeIcon className="user-list-item-icon" icon={faPlus} />
          <span className="user-list-add-user-title">Add Account User</span>
        </button>
      </div>
    );
  }

  function addMoveClientToUserButton(index, itemData) {
    return (
      <div className="float-right">
        <button
          type="button"
          className="btn btn-outline-primary btn-sm user-list-action-btn"
          onClick={() => moveClientToUser(index, itemData)}
          data-tip
          data-for="moveClientToUserTip"
        >
          <FontAwesomeIcon className="user-list-item-icon" icon={faUserTie} />
        </button>

        <ReactTooltip id="moveClientToUserTip" place="top" effect="solid">
          Move to Users
        </ReactTooltip>
      </div>
    );
  }

  let num = 0;

  // const emptyListAlert = <tr><td colSpan="10"><b>The list of users are empty!</b></td></tr>;

  const listItems = userListData.map((item, index) => {
    const { ...itemData } = item;
    return (
      <tr key={index}>
        <td>{++num}</td>
        {/* <td>{itemData.role}</td> */}
        <td>{itemData.contactId}</td>
        <td>{itemData.accountId}</td>
        <td>
          <Form.Check custom type="switch">
            <Form.Check.Input checked={itemData.status} onChange={() => {}} />
            <Form.Check.Label
              onClick={() => switchValue("status", index, itemData)}
            >
              {itemData.status ? `Active  ` : "Inactive"}
            </Form.Check.Label>
          </Form.Check>
        </td>
        <td>{itemData.firstName}</td>
        <td>{itemData.lastName}</td>
        <td>{itemData.username}</td>
        <td>{itemData.phone}</td>
        <td>{itemData.email}</td>
        <td>
          <button
            type="button"
            className="btn btn-outline-success btn-sm user-list-action-btn"
            onClick={() => replaceModalItem(index)}
            data-tip
            data-for="editDetailsTip"
          >
            <FontAwesomeIcon className="user-list-item-icon" icon={faEdit} />
          </button>

          <ReactTooltip id="editDetailsTip" place="top" effect="solid">
            Edit Details
          </ReactTooltip>

          <button
            type="button"
            className="btn btn-outline-danger btn-sm user-list-action-btn"
            onClick={() => deleteItem(index)}
            data-tip
            data-for="deleteTip"
          >
            <FontAwesomeIcon
              className="user-list-item-icon"
              icon={faTrashAlt}
            />
          </button>

          <ReactTooltip id="deleteTip" place="top" effect="solid">
            Delete
          </ReactTooltip>

          {userType === "client"
            ? addMoveClientToUserButton(index, itemData)
            : ""}
        </td>
      </tr>
    );
  });

  if (loading) {
    return <Spinner />;
  }

  let modalFormData = userListData[requiredItem];
  modalFormData = { ...modalFormData, password: "", requireLogin: false };

  return (
    <div className="user-list">
      {/* Add User Button */}
      {userType === "user" ? addUserAccountButton() : ""}
      {/* End Add User Button */}
      {/* Users Table */}
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>#</th>
            {/* <th>Role</th> */}
            <th>Contact ID</th>
            <th>Account ID</th>
            <th>Status</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Username</th>
            <th>Phone</th>
            <th>Email</th>
            <th className="table-actions-header">Actions</th>
          </tr>
        </thead>
        <tbody>
          {listItems}
          {/* { (userListData.length !==0) ? listItems : emptyListAlert } */}
        </tbody>
      </Table>
      {/* TODO: implement pagination */}
      <Pagination>
        <Pagination.First />
        <Pagination.Prev />
        <Pagination.Item>{1}</Pagination.Item>
        <Pagination.Ellipsis />

        <Pagination.Item>{3}</Pagination.Item>
        <Pagination.Item>{4}</Pagination.Item>
        <Pagination.Item active>{5}</Pagination.Item>
        <Pagination.Item>{6}</Pagination.Item>
        <Pagination.Item>{7}</Pagination.Item>

        <Pagination.Ellipsis />
        <Pagination.Item>{9}</Pagination.Item>
        <Pagination.Next />
        <Pagination.Last />
      </Pagination>
      {/* End Users Table */}
      {/* Modal Form */}
      <UserModalForm
        modalShow={show}
        editMode={editMode}
        currentUserAccountId={currentUserAccountId}
        handleModalShow={handleModalShow}
        handleModalClose={handleModalClose}
        modalFormData={modalFormData && editMode ? modalFormData : ""}
        saveModalDetails={saveModalDetails}
      />
      {/* End Modal Form */}
    </div>
  );
};

export default UserList;
